import { render, staticRenderFns } from "./BaseROInputMinimal.vue?vue&type=template&id=1f81b576&scoped=true"
import script from "./BaseROInputMinimal.vue?vue&type=script&lang=js"
export * from "./BaseROInputMinimal.vue?vue&type=script&lang=js"
import style0 from "./BaseROInputMinimal.vue?vue&type=style&index=0&id=1f81b576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81b576",
  null
  
)

export default component.exports